import React, { useState } from "react";
import "./Home.css";
import CategorySelect from "./components/CategorySelect";
import useVocab from "../../hooks/useVocab";
import { useTranslation } from "react-i18next";

const Home = () => {
	const { t } = useTranslation();
	const [selected, setSelected] = useState<string[]>([]);
	const { categories, loading } = useVocab();

	const handleChange = (chapterId: string) => {
		setSelected((prev) => (prev.includes(chapterId) ? prev.filter((id) => id !== chapterId) : [...prev, chapterId]));
	};
	const handleSubmit = () => {
		if (selected.length === 0) {
			alert(t("home.alert"));
			return;
		}
		window.location.href = `/practice?chapters=${selected.join(",")}`;
	};

	const handleCategorySelect = (chapterIds: string[], checked: boolean) => {
		setSelected((prev) => {
			if (checked) {
				return [...prev, ...chapterIds.filter((id) => !prev.includes(id))];
			} else {
				return prev.filter((id) => !chapterIds.includes(id));
			}
		});
	};

	if (loading) {
		return <div className="home-container"></div>;
	}

	return (
		<div className="home-container">
			<div className="header-gradient">
				<h1>{t("home.title")}</h1>
				<p className="subtitle">{t("home.subtitle")}</p>
			</div>
			<form
				onSubmit={(e) => {
					e.preventDefault();
					handleSubmit();
				}}>
				<div className="categories-list">
					{categories.map((category) => (
						<CategorySelect
							key={category.id}
							category={category}
							selected={selected}
							handleChange={handleChange}
							handleCategorySelect={handleCategorySelect}
						/>
					))}
				</div>
				<button
					type="submit"
					disabled={selected.length === 0}>
					{t("home.start")}
				</button>
			</form>
		</div>
	);
};

export default Home;
